<template>
    <b-overlay :show="loading" rounded="sm">
        <b-card title="Informações Básicas">
            <b-form @submit="submit" @submit.stop.prevent>

                <!-- Field -->
                <b-form-group
                    label="Matrícula">
                    <!-- Input -->
                    <b-form-input
                        v-model="form.matriculation"
                        :state="hasErrors('matriculation', errors)"
                    ></b-form-input>

                    <!-- Error -->
                    <has-errors :errors="errors" name="matriculation" />
                </b-form-group>

                <!-- Field -->
                <b-form-group
                    label="Nome">
                    <!-- Input -->
                    <b-form-input
                        v-model="form.name"
                        :state="hasErrors('name', errors)"
                    ></b-form-input>

                    <!-- Error -->
                    <has-errors :errors="errors" name="name" />
                </b-form-group>

                <!-- Field -->
                <b-form-group
                    label="Email">
                    <!-- Input -->
                    <b-form-input
                        v-model="form.email"
                        :state="hasErrors('email', errors)"
                    ></b-form-input>

                    <!-- Error -->
                    <has-errors :errors="errors" name="email" />
                </b-form-group>

                <!-- Field -->
                <b-form-group
                    label="Telefone">
                    <!-- Input -->
                    <the-mask
                        type="tel"
                        :mask="['(##) #####-####', '(##) ####-####']"
                        v-model="form.phone"
                        class="form-control"
                    ></the-mask>

                    <!-- Error -->
                    <has-errors :errors="errors" name="phone" />
                </b-form-group>

                <!-- Field -->
                <b-form-group
                    label="Data de Nascimento">
                    <!-- Input -->
                    <b-form-input
                        type="date"
                        v-model="form.birth"
                        :state="hasErrors('birth', errors)"
                    ></b-form-input>

                    <!-- Error -->
                    <has-errors :errors="errors" name="birth" />
                </b-form-group>

                <!-- Field -->
                <b-form-group
                    label="Gênero">

                    <b-form-radio v-model="form.genre" name="genre" value="M">Masculino</b-form-radio>
                    <b-form-radio v-model="form.genre" name="genre" value="F">Feminino</b-form-radio>
                    <b-form-radio v-if="genreAdvanced" v-model="form.genre" name="genre" value="MC">Mulher Cis</b-form-radio>
                    <b-form-radio v-if="genreAdvanced" v-model="form.genre" name="genre" value="MT">Mulher Trans</b-form-radio>
                    <b-form-radio v-if="genreAdvanced" v-model="form.genre" name="genre" value="HC">Homem Cis</b-form-radio>
                    <b-form-radio v-if="genreAdvanced" v-model="form.genre" name="genre" value="HT">Homem Trans</b-form-radio>
                    <b-form-radio v-if="genreAdvanced" v-model="form.genre" name="genre" value="NB">Não-Binárie</b-form-radio>
                    <b-form-radio v-model="form.genre" name="genre" value="O">Outro</b-form-radio>

                    <!-- Error -->
                    <has-errors :errors="errors" name="genre" />
                </b-form-group>

                <!-- Submit -->
                <b-button type="submit" variant="primary" :disable="loading">
                    Atualizar
                </b-button>

            </b-form>
        </b-card>
    </b-overlay>
</template>

<script>
export default {
    props: ['endpointShow', 'endpointUpdate', 'genreAdvanced'],
    data() {
        return {
            loading: false,
            errors: {},
            form: {
                name: null,
                email: null,
                birth: null,
                genre: null,
                phone: null,
                matriculation: null,
            }
        }
    },
    created() {
        this.load();
    },
    methods: {

        load() {
            this.loading = true;
            axios.get(this.endpointShow)
                .then((result) => {
                    const response = result.data.data
                    this.form.name = response.student.name
                    this.form.email = response.student.email
                    this.form.phone = response.student.phone
                    this.form.birth = response.student.birth
                    this.form.genre = response.student.genre
                    this.form.matriculation = response.student.matriculation
                })
                .finally(() => this.loading = false)
        },

        submit() {
            this.loading = true;
            axios.put(this.endpointUpdate, this.form)
                .then((result) => {
                    // Redirect
                    this.redirectIfNeed(result)

                    // Clear Errors
                    this.errors = {}
                })
                .catch((errors) => {
                    // Check Errors
                    this.errors = this.setErrors(errors)
                })
                .finally(() => this.loading = false)
        },

    }
}
</script>

<style scoped>

</style>
